<template>
    <div>

        <div class="row row-cols-1 row-cols-sm-2">
            <div class="col">
                <select-input :floating="true" label="country" v-model="form.country_id" :error="form.errors.country_id">
                    <option :value="country.id" v-for="country in countries">{{ country.name }}</option>
                </select-input>
            </div>
            <div class="col"></div>
            <div class="col w-100">
                <text-input :floating="true" label="company" v-model="form.company" :error="form.errors.company" />
            </div>
            <div class="col">
                <text-input :floating="true" label="salutation" v-model="form.salutation" :error="form.errors.salutation" />
            </div>
            <div class="col">
                <text-input :floating="true" label="title" v-model="form.title" :error="form.errors.title" />
            </div>
            <div class="col">
                <text-input :floating="true" label="first_name" v-model="form.first_name" :error="form.errors.first_name" />
            </div>
            <div class="col">
                <text-input :floating="true" label="last_name" v-model="form.last_name" :error="form.errors.last_name" />
            </div>
            <div class="col w-100">
                <div class="row">
                    <div class="col-8">
                        <text-input :floating="true" label="street" v-model="form.street" :error="form.errors.street" />
                    </div>
                    <div class="col-4">
                        <text-input :floating="true" label="house_number" v-model="form.house_number" :error="form.errors.house_number" />
                    </div>
                </div>
            </div>
            <div class="col w-100">
                <div class="row">
                    <div class="col-sm-4">
                        <text-input :floating="true" label="zip_code" v-model="form.zip_code" :error="form.errors.zip_code" />
                    </div>
                    <div class="col-sm-8">
                        <text-input :floating="true" label="city" v-model="form.city" :error="form.errors.city" />
                    </div>
                </div>
            </div>
            <div class="col">
                <text-input :floating="true" label="county" v-model="form.county" :error="form.errors.county" />
            </div>
            <div class="col">
                <text-input :floating="true" label="phone" v-model="form.phone" type="tel" :error="form.errors.phone" />
            </div>
        </div>
        <textarea-input :floating="true" label="notes" v-model="form.notes" :error="form.errors.notes" />
        <checkbox-input :floating="true" label="als Standard Rechnungsadresse festlegen" v-model="form.default_billing_address" :error="form.errors.default_billing_address" />
        <checkbox-input :floating="true" label="als Standard Lieferadresse festlegen" v-model="form.default_delivery_address" :error="form.errors.default_delivery_address" />
        <submit-button :form="form" />
    </div>
</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'form',
            'countries',
        ],
        data() {
            return {

            }
        },
        components: {
            TextInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
        },
        watch: {
        },
        methods: {
        },
    }
</script>